import React from "react";
import { Col, Row, FormGroup, Label, Button, Input } from "reactstrap";

const Renderforminput = (props) => {
 
  return (
    <Row form>
      {props.inputFields.map((modalInput, index) => {
        return (
          <Col md={6} key={index}>
            <FormGroup>
              {modalInput.inputType === "select" ? (
                <Input
                  type={modalInput.inputType}
                  name={modalInput.name}
                  id={`select-${index}`}
                  className="select-input"
                  defaultValue="Choose an option"
                  onChange={(e) => props.handleMultipleSelect(e.target.value)}
                >
                  <option value="Choose an option" disabled>
                    Choose an option
                  </option>
                  {props.dropDownOptions.map((dropDown, index) => {
                    return (
                      <option
                        key={index}
                        value={dropDown.assessor_group__assessor_name}
                      >
                        {dropDown.assessor_group__assessor_name}
                      </option>
                    );
                  })}
                </Input>
              ) : (
                <React.Fragment>
                  <Input
                    placeholder="Enter an email Id"
                    type={modalInput.inputType}
                    name={modalInput.name}
                    id={`email-${index}`}
                    className="email-input"
                    onChange={(e) =>
                      props.handleMultipleEmail(e.target.value, index)
                    }
                  />
                  <span id={`error-${index}`}></span>
                </React.Fragment>
              )}
            </FormGroup>
          </Col>
        );
      })}
      <div className="form-button-wrapper">
        <FormGroup check>
          {props.isDisabled === true ? (
            <Label check className="disabled-button">
              <Input
                type="checkbox"
                checked={props.isChecked}
                style={{ cursor: "not-allowed" }}
                disabled
              />
              ADD ANOTHER
            </Label>
          ) : (
            <Label check>
              <Input
                type="checkbox"
                checked={props.isChecked}
                onChange={props.handleInputFields}
              />
              ADD ANOTHER
            </Label>
          )}
        </FormGroup>
        {props.isDisabled === true ? (
          <Button type="submit" className="disabled-button" value="submit">
            Submit
          </Button>
        ) : (
          <Button
            className="active-button"
            onClick={props.handleInviteModalSubmit}
          >
            Submit
          </Button>
        )}
      </div>
    </Row>
  );
};

export default Renderforminput;



// WEBPACK FOOTER //
// ./src/new/Components/CompletedAssessment/Invite-Respondants-Modal/invite-respondants-input.jsx